export default __webpack_public_path__ + "static/img04-85f22e774e177ddee3e87b68e8847cba.png";